export default __webpack_public_path__ + "static/media/space.41584ed5.mp4";